module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-lightning-rain-fill-e743e2b3.svg";